<app-info-panel [isOpen]="isOpen" [title]="title" (closed)="closed.emit()">
  <app-info-panel-section [columns]="1">
    <app-info-panel-field label="Name" i18n-label [value]="analysis?.AnalysisName" />
    <app-info-panel-field label="Description" i18n-label [value]="analysis?.AnalysisDescription" />
    <app-info-panel-field label="Application" i18n-label [value]="analysis?.Application" />
  </app-info-panel-section>
  @if (contextActions) {
    <app-info-panel-expansion-section title="Curate" i18n-title [columns]="1">
      @switch (curateOptionsState) {
        @case (LoadingState.Loading) {
          <app-info-panel-link text="Curation options loading..." i18n-text [loading]="true" />
        }

        @case ('empty') {
          <app-info-panel-field value="No curation options for this analysis" i18n-value />
        }

        @default {
          <app-info-panel-link
            i18n-text
            [text]="'Open report'"
            [href]="viewResultHref"
            [trailingIcon]="'arrow_forward'"
            (activated)="viewResultClicked.emit()"
          />

          @for (plugin of contextActions.plugins.items; track plugin.pluginId) {
            <app-info-panel-link
              [text]="'Open results in viewer'"
              [href]="pluginHref(plugin.pluginId)"
              [trailingIcon]="pluginHref(plugin.pluginId) ? 'arrow_forward' : undefined"
              (activated)="pluginLaunched.emit(plugin.pluginId)"
            />
          }
        }
      }
    </app-info-panel-expansion-section>
  }
  <app-info-panel-expansion-section title="Details" i18n-title>
    <app-info-panel-field label="Sample" i18n-label [value]="analysis?.SampleName" />
    <app-info-panel-field label="Sample Description" i18n-label [value]="analysis?.SampleDescription" />

    <app-info-panel-field label="Panel" i18n-label [value]="analysis?.PanelName" />
    <app-info-panel-field label="Panel Description" i18n-label [value]="analysis?.PanelDescription" />

    <app-info-panel-field label="Status" i18n-label [value]="analysis?.Status" />
    <app-info-panel-field label="Completed On" i18n-label [value]="analysis?.CompletedOn | utcDate" />

    <app-info-panel-field label="Created By" i18n-label [value]="analysis?.UserName" />
    <app-info-panel-field label="Created On" i18n-label [value]="analysis?.CreatedOn | utcDate" />

    <app-info-panel-field label="Groups" i18n-label [value]="groupNames" />
    <app-info-panel-field label="Folder" i18n-label [value]="analysis?.FolderName" />
  </app-info-panel-expansion-section>
  @if (downloads.length > 0) {
    <app-info-panel-expansion-section title="Downloads" i18n-title [columns]="1" [expanded]="false">
      @for (type of downloads; track type) {
        <app-info-panel-link
          [text]="downloadMeta[type].text"
          trailingIcon="arrow_downward"
          (activated)="downloadRequested.emit(type)"
        />
      }
    </app-info-panel-expansion-section>
  }
</app-info-panel>
